import { render } from "./createPublicGroupComponent.vue?vue&type=template&id=fefc7282"
import script from "./createPublicGroupComponent.vue?vue&type=script&lang=js"
export * from "./createPublicGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__